import request from '@/utils/request'
import { ResponseData } from './modular'

/**
 * @description: 获取活动列表
 * @param {*}
 * @return {*}
 */
export const getActivityListApi = (data?: any) => {
  return request<ResponseData<any>>('/web/getAct', {
    method: 'GET',
    data,
  })
}

/**
 * @description: 获取活动分类
 * @param {*}
 * @return {*}
 */
export const getActivityCategoryListApi = (data?: any) => {
  return request<ResponseData<any>>('/web/getAC', {
    method: 'GET',
    data,
  })
}

/**
 * @description: 获取玩家奖金列表
 * @param {*}
 * @return {*}
 */
export const getPlayerBonusListApi = () => {
  return request<ResponseData<any>>('/web/getPlayerBonus', {
    method: 'GET',
  })
}

/**
 * @description: 领取奖金
 * @param {*}
 * @return {*}
 */
export const receiveBonusApi = (data?: any) => {
  return request<ResponseData<any>>('/web/receiveBonus', {
    method: 'POST',
    data,
  })
}

/**
 * @description: 获取抽奖配置
 * @param {*}
 * @return {*}
 */
export const getLotteryConfigListApi = () => {
  return request<ResponseData<any>>('/web/getLotteryConfigList', {
    method: 'GET',
  })
}
/**
 * @description: 获取中奖记录
 * @param {*}
 * @return {*}
 */
export const getLotteryRecordListApi = (data?: any) => {
  return request<ResponseData<any>>('/web/getLotteryRecords', {
    method: 'GET',
    data,
  })
}

/**
 * @description: 抽奖
 * @param {*}
 * @return {*}
 */
export const lotteryApi = () => {
  return request<ResponseData<any>>('/web/lottery', {
    method: 'POST',
  })
}
